module.exports = __webpack_public_path__ + "img/kobenhavns-kommune-logo.f5b0d11f.svg";